<template>
  <div>
    <TextHeader :title="title" />
    <div
      class="columns is-mobile has-text-left animate__animated animate__fadeInUp"
      style="justify-content: center"
    >
      <div class="column is-9-dektop is-10-tablet is-10-mobile">
        <div class="columns info-first">
          <div class="column is-5 info">
            <prismic-rich-text
              :class="`mist-${language}-h2`"
              class="title"
              :field="titleLeft"
            />
            <prismic-rich-text
              :class="`mist-${language}-p`"
              class="sub-title"
              :field="addressTitle"
            />
            <prismic-rich-text
              :class="`mist-${language}-p`"
              :field="addressInfo"
              class="space"
            />
            <prismic-rich-text
              :class="`mist-${language}-p`"
              class="sub-title"
              :field="contactTitle"
            />
            <div class="info-icon" style="margin-bottom: 10px">
              <img :src="phoneIcon" style="height: 25px" />
              <p :class="`mist-${language}-p`" style="padding-left: 26px">
                <a :href="`tel:${phone.replaceAll(` `, ``)}`">{{ phone }}</a>
              </p>
            </div>
            <div class="info-icon">
              <img :src="emailIcon" style="height: 25px" />
              <p :class="`mist-${language}-p`" style="padding-left: 26px">
                <a :href="`mailto:${email}`">{{ email }}</a>
              </p>
            </div>
            <prismic-rich-text
              :class="`mist-${language}-p`"
              :field="info"
              style="padding-top: 44px"
            />
          </div>
          <div class="column is-5 info info-sec">
            <prismic-rich-text
              :class="`mist-${language}-h2`"
              class="title"
              :field="titleRight"
            />
            <div style="padding-top: 40px">
              <b-field
                :class="`label-${language}`"
                class="has-text-left"
                :label="inputField.name.label"
              >
                <b-input
                  :class="`label-${language}`"
                  :placeholder="inputField.name.placeholder"
                ></b-input>
              </b-field>
              <b-field
                :class="`label-${language}`"
                class="has-text-left label"
                :label="inputField.email.label"
              >
                <b-input
                  :class="`label-${language}`"
                  :placeholder="inputField.email.placeholder"
                ></b-input>
              </b-field>
              <b-field
                :class="`label-${language}`"
                class="label"
                :label="inputField.info.label"
              >
                <b-input
                  :class="`label-${language}`"
                  class="has-text-left"
                  :placeholder="inputField.info.placeholder"
                  type="textarea"
                ></b-input>
              </b-field>
              <div class="has-text-centered" style="padding-top: 20px">
                <b-button :class="`mist-${language}-btn`" class="mist-btn">{{
                  inputField.label
                }}</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  components: {
    TextHeader: () => import(`@/components/TextHeader`),
  },
  data() {
    return {
      titleLeft: null,
      title: null,
      titleRight: null,
      addressTitle: null,
      addressInfo: null,
      contactTitle: null,
      email: null,
      emailIcon: null,
      info: null,
      phone: null,
      phoneIcon: null,
    };
  },
  computed: {
    ref() {
      return this.$store.getters["cms/ref"];
    },
    language() {
      return this.$store.getters["language/language"];
    },
    inputField() {
      if (this.language === "en") {
        return {
          email: {
            label: "Email:",
            placeholder: "Enter your email",
          },
          name: {
            label: "Name:",
            placeholder: "Enter your name",
          },
          info: {
            label: "Message:",
            placeholder: "Enter your message",
          },
          label: "Submit",
        };
      } else {
        return {
          email: {
            label: "ชื่อ",
            placeholder: "กรอกชื่อ",
          },
          name: {
            label: "อีเมล",
            placeholder: "กรอกอีเมล",
          },
          info: {
            label: "ข้อความ",
            placeholder: "กรอกข้อความของคุณ",
          },
          label: "ส่ง",
        };
      }
    },
  },
  watch: {
    language() {
      if (this.language === "en") {
        $(".input, .textarea").css("font-family", "Open Sans");
      } else {
        $(".input, .textarea").css("font-family", "Prompt");
      }
      this.getOurTeam();
    },
  },
  created() {
    this.getOurTeam();
  },
  methods: {
    async getOurTeam() {
      const params = {
        ref: this.ref,
        q: `[[at(document.tags, ["Contact Us","${this.language}"])]]`,
      };
      const res = await this.$http.get(
        process.env.VUE_APP_URL + "/api/v2/documents/search",
        { params }
      );
      const data = res.data.results[0].data;
      console.log(data);
      this.title = data.name[0].text;
      this.titleLeft = data.title_left;
      this.titleRight = data.title_right;
      this.addressTitle = data.address_title;
      this.addressInfo = data.address_info;
      this.contactTitle = data.contact_title;
      this.phone = data.phone_no[0].text;
      this.phoneIcon = data.phone_icon.url;
      this.email = data.email[0].text;
      this.emailIcon = data.email_icon.url;
      this.info = data.info;
    },
  },
};
</script>
<style>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
</style>
<style scoped>
>>> a {
  color: #272727;
}
.column {
  padding: 0px;
}
.mist-btn {
  background-color: #0053c6;
  height: 55px;
  max-width: 211px;
  width: 100%;
  font-size: 18px;
  border-radius: 0px;
  font-weight: 600;
  color: #fff;
}
.mist-btn:hover {
  -webkit-transition: all 0.5s ease !important;
  -moz-transition: all 0.5s ease !important;
  -ms-transition: all 0.5s ease !important;
  transition: all 0.5s ease !important;
  background-color: #66c3d1;
}
.label-en {
  font-family: Open Sans;
}
.label-th {
  font-family: "Prompt", sans-serif;
}
>>> .label {
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
>>> .input {
  height: 55px;
}
>>> .input,
>>> .textarea,
>>> .taginput .taginput-container.is-focusable,
>>> .select select {
  border-radius: 0px;
}
.title {
  padding-bottom: 27px;
  border-bottom: 1px solid #000000;
}
.sub-title {
  padding: 23px 0 18px;
}
>>> h2 {
  font-weight: 600 !important;
}
.info-icon {
  display: flex;
}
.info-first {
  padding: 70px 0 86px;
  justify-content: space-between;
}
.space {
  padding-bottom: 28px;
}
@media (max-width: 768px) {
  .info {
    text-align: left;
  }
  .space {
    padding-bottom: 0px;
  }
  .title {
    margin: 0px;
  }
  .info-first {
    padding: 70px 0;
    justify-content: space-between;
  }
  .info-icon {
    display: flex;
    justify-content: left;
  }
  .info-sec {
    padding-top: 40px;
  }
}
</style>